<script>
  export let testid = undefined;
  export let size = 'xl';
  export let responsive = false;
</script>

{#if size === 'xxl'}
  <h1 class='heading {size}' class:responsive data-cy={testid}><slot /></h1>
{:else if size === 'xl'}
  <h2 class='heading {size}' class:responsive data-cy={testid}><slot /></h2>
{:else if size === 'l'}
  <h3 class='heading {size}' class:responsive data-cy={testid}><slot /></h3>
{:else if size === 'm'}
  <h4 class='heading {size}' class:responsive data-cy={testid}><slot /></h4>
{:else if size === 's'}
  <h5 class='heading {size}' class:responsive data-cy={testid}><slot /></h5>
{:else if size === 'xs'}
  <h6 class='heading {size}' class:responsive data-cy={testid}><slot /></h6>
{:else if size === 'xxs'}
  <div class='heading {size}' class:responsive data-cy={testid}><slot /></div>
{/if}

<style lang="postcss">
  .heading {
    margin: var(--Heading--margin, 0);
    padding: 0;
    text-overflow: var(--Heading--text-overflow);
    white-space: var(--Heading--white-space);
    overflow: var(--Heading--overflow);
    color: var(--Heading--color, var(--color--default--text));

    &.xxl { font: var(--font--outfit-title-40); }

    &.xl { font: var(--font--outfit-title-32); }

    &.l { font: var(--font--outfit-title-24); }

    &.m { font: var(--font--outfit-title-20); }

    &.s { font: var(--font--outfit-title-16); }

    &.xs { font: var(--font--outfit-title-14); }

    &.xxs { font: var(--font--outfit-title-12); }
  }

  @media (--screen-width--below-tablet) {
    .responsive.xxl {
      font: var(--font--outfit-title-32);
    }

    .responsive.l {
      font: var(--font--outfit-title-16);
    }
  }
</style>
